import { connect, MapStateToProps } from 'react-redux'
import modelFilterOptionsSelector from '../../redux/selectors/models/modelFilterOptionsSelector'
import modelSelectedFiltersSelector from '../../redux/selectors/models/modelSelectedFiltersSelector'
import { applyFilter, removeEntireFilter, resetFiltersState } from '../../redux/actions/app/filter.actions'
import { Props } from '../attribute-filters'
import isTranslationDebugEnabledSelector
    from '../../redux/selectors/isTranslationDebugEnabledSelector'

type StateProps = Pick<Props, 'filterOptions' | 'selectedFilters' | 'translationDebugEnabled'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    filterOptions: modelFilterOptionsSelector(state),
    selectedFilters: modelSelectedFiltersSelector(state), 
    translationDebugEnabled: isTranslationDebugEnabledSelector(state),
})

type DispatchProps = Pick<Props, 'applyFilter' | 'removeFilter' | 'resetFilters'>

const mapDispatchToProps: DispatchProps = {
    applyFilter,
    removeFilter: removeEntireFilter,
    resetFilters: resetFiltersState,
}

export default connect(mapStateToProps, mapDispatchToProps)